import "./Edit.module.css";
import StudioThorneHeader from "@/reusable_sections/Header";
import TheCurrentEdit from "./sections/TheCurrentEdit";
import ArchitecturalFoundations from "./sections/ArchitecturalFoundations";
import VisualAnthology from "./sections/VisualAnthology";
import EvolutionOfAGarment from "./sections/EvolutionOfAGarment";
import SecureTheLineSheet from "./sections/SecureTheLineSheet";
import StudioThorneFooter from "@/reusable_sections/Footer";
export default function EditPage() {
  return <div>
      <StudioThorneHeader />
      <TheCurrentEdit />
      <ArchitecturalFoundations />
      <VisualAnthology />
      <EvolutionOfAGarment />
      <SecureTheLineSheet />
      <StudioThorneFooter />
    </div>;
}